export enum ORDER_CONTRACTOR_TABS {
  BUYER = 0,
  PAYER = 1,
  RECEIVER = 2,
  SELLER = 3,
  ORGANIZATION_UNIT = 4,
}
